import {
  Configuration,
  DiaryControllerApi,
  DrinkControllerApi,
  MealControllerApi,
  MeasurementControllerApi,
  TrainingControllerApi,
  UserProfileControllerApi,
  WaterControllerApi,
} from './generated';

export declare interface IApiControllers {
  diary: DiaryControllerApi,
  drink: DrinkControllerApi,
  meal: MealControllerApi,
  measurement: MeasurementControllerApi,
  training: TrainingControllerApi,
  userProfile: UserProfileControllerApi
  water: WaterControllerApi
}

export class ApiControllers implements IApiControllers {

  private readonly _diary: DiaryControllerApi;
  private readonly _drink: DrinkControllerApi;
  private readonly _meal: MealControllerApi;
  private readonly _measurement: MeasurementControllerApi;
  private readonly _training: TrainingControllerApi;
  private readonly _userProfile: UserProfileControllerApi;
  private readonly _water: WaterControllerApi;

  constructor(configuration: Configuration) {
    this._diary = new DiaryControllerApi(configuration);
    this._drink = new DrinkControllerApi(configuration);
    this._meal = new MealControllerApi(configuration);
    this._measurement = new MeasurementControllerApi(configuration);
    this._training = new TrainingControllerApi(configuration);
    this._userProfile = new UserProfileControllerApi(configuration);
    this._water = new WaterControllerApi(configuration);
  }

  get diary() {
    return this._diary;
  }

  get drink() {
    return this._drink;
  }

  get meal() {
    return this._meal;
  }

  get measurement() {
    return this._measurement;
  }

  get training() {
    return this._training;
  }

  get userProfile() {
    return this._userProfile;
  }

  get water() {
    return this._water;
  }

}


// WEBPACK FOOTER //
// ./src/api/controllers.ts